/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { NvHigListItemLeadData, NvHigListItemLeadingElementType } from '../../../models/hig-list-item.types';

@Component({
    selector: 'nv-hig-list-item-lead',
    templateUrl: './nv-hig-list-item-lead.component.html',
    styleUrl: './nv-hig-list-item-lead.component.scss',
    imports: [MatIconModule]
})
export class NvHigListItemLeadComponent {
    data: NvHigListItemLeadData;
    @Input() set cardData(x: NvHigListItemLeadData) {
        this.data = x;
    }

    @Output() checkboxClicked = new EventEmitter<boolean>();

    leadElementType = NvHigListItemLeadingElementType;

    checkBoxClick($event: MatCheckboxChange): void {
        this.checkboxClicked.emit($event.checked);
    }
}
